import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { router } from "@inertiajs/react";
import { ThemeProvider } from "next-themes";
import { useEffect } from "react";
import { toast } from "sonner";

export default function Layout({ children }: React.PropsWithChildren) {
  useEffect(() => {
    const removeListener = router.on("flash", (event) => {
      if (event.detail.flash.alert) {
        toast.error(event.detail.flash.alert);
      }
      if (event.detail.flash.notice) {
        toast.info(event.detail.flash.notice);
      }
    });

    // Remove the listener
    return removeListener;
  }, []);

  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <TooltipProvider>{children}</TooltipProvider>
      <Toaster />
    </ThemeProvider>
  );
}
